import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import ProtectedRoute from '@features/ProtectedRoute/ProtectedRoute';
import React, {lazy, Suspense} from 'react';
import AppLayout from '@features/AppLayout/AppLayout';
import Loader from '@components/Loader/Loader';

const Start = lazy(() => import('@pages/Start/Start'));
const Home = lazy(() => import('@pages/Home/Home'));
const Checkin = lazy(() => import('@pages/Checkin/Checkin'));
const Checkout = lazy(() => import('@pages/Checkout/Checkout'));
const Reservation = lazy(() => import('@pages/Reservation/Reservation'));
const Manage = lazy(() => import('@pages/Manage/Manage'));
const AgreementPaper = lazy(
  () => import('@pages/Manage/components/AgreementPaper/AgreementPaper')
);
const ReservationPaper = lazy(
  () => import('@pages/Manage/components/ReservationPaper/ReservationPaper')
);
const UpdateReservation = lazy(
  () => import('@pages/UpdateReservation/UpdateReservation')
);
const StatisticsPage = lazy(() => import('@pages/Statistics/StatisticsPage'));
const StatisticsDetails = lazy(
  () => import('@pages/Statistics/StatisticsDetails')
);
const Profile = lazy(() => import('@pages/Profile/Profile'));
const FAQ = lazy(() => import('@pages/FAQ/FAQ'));
const Support = lazy(() => import('@pages/Support/Support'));
const PageNotFound = lazy(() => import('@pages/404/404'));

const withSuspense = (Component: React.FC) => (
  <Suspense fallback={<Loader/>}>
    <Component/>
  </Suspense>
);

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppLayout/>}>
      <Route path="/" element={withSuspense(Start)}/>
      <Route element={<ProtectedRoute/>}>
        {/* /login existed in the previous homepage, this redirect ensures that people who saved the link to login don't fall on 404  */}
        <Route path="login" element={withSuspense(Start)}/>
        <Route path="home" element={withSuspense(Home)}/>
        <Route path="checkin" element={withSuspense(Checkin)}/>
        <Route path="checkout" element={withSuspense(Checkout)}/>
        <Route path="reservation" element={withSuspense(Reservation)}/>
        <Route path="manage" element={withSuspense(Manage)}/>
        <Route path="profile" element={withSuspense(Profile)}/>
        <Route path="statistics" element={withSuspense(StatisticsPage)}/>
        <Route
          path="statistics/details"
          element={withSuspense(StatisticsDetails)}
        />
        <Route path="faq" element={withSuspense(FAQ)}/>
        <Route path="support" element={withSuspense(Support)}/>
        <Route
          path="manage/agreement/:agreementId"
          element={withSuspense(AgreementPaper)}
        />
        <Route
          path="manage/reservation/:tracCode/:reservationId"
          element={withSuspense(ReservationPaper)}
        />
        <Route
          path="manage/reservation/:tracCode/:reservationId/update"
          element={withSuspense(UpdateReservation)}
        />
      </Route>
      <Route path="*" element={withSuspense(PageNotFound)}/>
    </Route>
  )
);
